import { render, staticRenderFns } from "./vs-popover.vue?vue&type=template&id=59d3fac4"
import script from "./vs-popover.vue?vue&type=script&lang=js"
export * from "./vs-popover.vue?vue&type=script&lang=js"
import style0 from "./vs-popover.vue?vue&type=style&index=0&id=59d3fac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports